<template>
  <div>
    <b-modal
          hide-footer
          size="md"
          centered
          ref="addbrower"
          id="add-brower-modal"
          title="ADICIONAR CORRETOR"
        >
              <template #modal-title>
                <div class="titulo-modal">ADICIONAR CORRETOR</div>
              </template>
              <b-form-group
                id="input-group-name"
                label="Corretores:"
                label-for="input-broker"
              >
              <select
              id="input-uf-creci"
              class="form-control"
              v-model="corretorId"
              placeholder="Selecione o corretor"
                >
                  <option disabled selected :value="''">Selecione o corretor</option>
                  <option v-for="data in corretor" :key="data.id" :value="data.id" >{{data.nome}}</option>
              </select>
              </b-form-group>
      <div class="container-buttons-form pt-3">
        <button @click="cancelNewBrower" class="button-cancel">
          Cancelar
        </button>
        <button @click="onSubmit" class="button-save">Salvar</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import brokerlink from '../brokerlink/brokerlink'
export default brokerlink
</script>

<style scoped>
.titulo-modal{
    color:white;
    font: normal normal 600 18px/24px Segoe UI;
    display: flex;
    align-items: center;
}
#add-new-user{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.container-user-form{

    align-items: center;
    align-content: center;
    align-self: center;
    flex-direction: 50px;

}
#body-poup{
  display: flex;
  width: 50%;
  justify-content: center;
  align-items: center;
}

#input-group-name{
    grid-row: 4;
    grid-column: 1/5;
    align-items: center;
    align-content: center;
    justify-content: center;
    position: relative
}

.container-buttons-form{
    grid-row: 8;
    grid-column: 1/11;
}

.title-1,
.title-2{
    color: #008148;
}

.title-3{
    color: #008148;
    font-weight: 800;
}

.title-1{
  grid-row: 1;
}

.title-2{
  grid-row: 4;
}
.title-3{
  grid-row: 6;
}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

/* estilização do cabeçalho do popup */

.container-hearder{
  background-color: #008144;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  padding: 25px 0;
}

.title-hearder{
  color: white;
  grid-column: 1;
  grid-row: 1;
  text-transform: uppercase;
  justify-self: center;
}

.container-close-button{
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
  align-self: center;
}

.container-close-button img{
  width: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/brokerlink/brokerlink.vue